export default __webpack_public_path__ + "static/media/logout.e12727e4.svg";